export enum FinancialBucket {
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Year = "Year"
}

export enum FinancialComparison {
  None = "None",
  PreviousPeriod = "PreviousPeriod",
  SamePeriodLastYear = "SamePeriodLastYear",
  Custom = "Custom"
}

export enum FinancialSalesChannel {
  WhatsApp = "WhatsApp",
  AppClient = "AppClient",
  AppReseller = "AppReseller",
  Advertising = "Advertising"
}

export enum AdCampaignStatus {
  Active = "Active",
  Paused = "Paused",
  Ended = "Ended"
}
